import styled from '@emotion/styled';

import { tokens, Icon } from '@hotjar/hotsauce';

export const PlanColumnStyles = {
  TrafficCoverageLabel: styled.div`
    ${tokens.text('caption')};

    color: ${tokens.color.text_light};
    white-space: pre-line;
  `,
  MaxTrafficCoverageWrapper: styled.div`
    display: flex;
    align-items: center;
    height: ${tokens.spacer.x2};
  `,
  MaxTrafficCoverageLabel: styled.div`
    ${tokens.text('caption')};

    color: ${tokens.color.text_light};
  `,
  MaxTrafficCoverageIcon: styled(Icon)`
    transform: scale(0.7);
    margin-right: 2px;
    margin-top: 2px;
    font-weight: bolder;
  `,
};
